import React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { LocationDetailRoute } from "./detailRoute";
import { LocationCreateRoute } from "./create/create";
import { LocationList } from "./list";
import { ConsoleContext } from "../../mobxStores/consoleContext/consoleContext";

const LocationRoute: React.FC = () => {
  const { org } = ConsoleContext;

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<LocationList />} />
        <Route path={`-create/*`} element={<LocationCreateRoute />} />
        <Route path={`:location/*`} element={<LocationDetailRoute />} />
      </Routes>
    </Layout>
  );
};

export default LocationRoute;
